import React from "react";
import { Link } from "react-router-dom";

const SAGE = "#FF4D6D"; // brand accent — coral
const INK = "#1B1340"; // dark navy type
const DOT = "#FFC233"; // amber accent dot

/**
 * Curate brand mark — sage-on-charcoal "C" tile with the small accent dot.
 * Matches the landing page identity exactly.
 */
export function CurateMark({ size = 28, onDark = false }) {
  return (
    <div
      className="relative flex items-center justify-center shrink-0"
      style={{ width: size, height: size, background: SAGE }}
    >
      <span
        className="font-display font-black tracking-tighter"
        style={{ color: "#fff", fontSize: Math.floor(size * 0.45) }}
      >
        C
      </span>
      <span
        className="absolute"
        style={{
          width: Math.max(4, Math.floor(size * 0.16)),
          height: Math.max(4, Math.floor(size * 0.16)),
          right: -Math.floor(size * 0.08),
          bottom: -Math.floor(size * 0.08),
          background: DOT,
        }}
      />
    </div>
  );
}

/**
 * Full Curate wordmark: brand tile + "Curate" + "curated.io" mono caption.
 */
export function CurateWordmark({ size = 28, link = true, onDark = false, mono = true }) {
  const inner = (
    <div className="flex items-center gap-3">
      <CurateMark size={size} onDark={onDark} />
      <div className="flex items-baseline gap-2">
        <span className="font-display font-bold tracking-tight text-lg">Getcurate</span>
        {mono && (
          <span
            className="font-mono text-[10px] uppercase tracking-[0.25em] hidden sm:inline"
            style={{ color: onDark ? "rgba(255,255,255,0.4)" : "rgba(15,18,16,0.45)" }}
          >
            getcurate.shop
          </span>
        )}
      </div>
    </div>
  );
  return link ? <Link to="/">{inner}</Link> : inner;
}
